import { Component, OnDestroy, OnInit } from "@angular/core";
import {
  ReactiveFormsModule,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";

import Swal from "sweetalert2";
import { AuthService } from "../../services/auth.service";
import { CommonModule } from "@angular/common";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
  imports: [CommonModule, ReactiveFormsModule],
})
export class LoginComponent implements OnInit, OnDestroy {
  formLogin!: UntypedFormGroup;
  loading: boolean = false;
  message: string = "";
  constructor(
    private formBuilder: UntypedFormBuilder,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    this.createForm();
  }

  ngOnDestroy(): void {}

  createForm() {
    this.formLogin = this.formBuilder.group({
      email: ["", Validators.required],
      password: ["", Validators.required],
    });
  }

  async login() {
    if (this.formLogin.invalid) {
      this.formLogin.get("email")?.markAsTouched();
      this.formLogin.get("password")?.markAsTouched();
      return;
    } else {
      this.loading = true;
      await this.authService
        .login(this.formLogin.value)
        .then((res) => {
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          switch (error?.code) {
            case "auth/wrong-password":
            case "auth/invalid-credential":
              this.message = "E-mail ou senha inválidos.";
              break;
            case "auth/invalid-email":
              this.message = "Informe um e-mail válido.";
              break;
            case "auth/user-not-found":
              this.message = "Nenhum usuário encontrado.";
              break;
            case "auth/user-disabled":
            case "admin/disabled":
              this.message = "Usuário desativado.";
              break;
            case "admin/not-found":
              this.message = "Sem permissão de administrador.";
              break;
            default:
              this.message = error.message;
              break;
          }

          const swalWithBootstrapButtons = Swal.mixin({
            customClass: {
              confirmButton: "btn btn-success",
              cancelButton: "btn btn-danger",
            },
            buttonsStyling: false,
          });

          swalWithBootstrapButtons.fire({
            text: this.message,
            icon: "error",
            showCancelButton: false,
            confirmButtonText: "OK",
            cancelButtonText: "Não, cancelar!",
            reverseButtons: false,
          });
        });
    }
  }
}
